import { render } from "./ModalImportExcel.vue?vue&type=template&id=f31170b8"
import script from "./ModalImportExcel.vue?vue&type=script&lang=js"
export * from "./ModalImportExcel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__